import * as React from "react";
import Loading from "./Utils/Loading";
import { db } from "../FirebaseConfig";
import { useParams } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import EventDetailsContent from "./_sections/EventInfo/EventDetailsContent";
import { Box, Typography } from "@mui/joy";
import Tabs from "@mui/joy/Tabs";
import TabList from "@mui/joy/TabList";
import Tab, { tabClasses } from "@mui/joy/Tab";
import TabPanel from "@mui/joy/TabPanel";
import ParticipantDetails from "./_sections/EventInfo/ParticipantDetails";
import EventStats from "./_sections/EventInfo/EventStat";

interface RouteParams {
  [key: string]: string | undefined;
  id: string;
}

function parseSlug(slug: string): string {
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export default function EventDetails() {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<any>({});
  const { id } = useParams<RouteParams>();
  const { userData } = UserAuth();
  const [index, setIndex] = React.useState(0);

  const eventCategory = data?.category || "";

  // Pass the event name to the ParticipantDetails component
  const eventNametoBePassed = parseSlug(id ?? "").toLowerCase();
  React.useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const eventData = await db
          .collection("Events")
          .doc(parseSlug(id ?? "").toLowerCase())
          .get();
        if (!eventData.exists) {
          setLoading(false);
        } else {
          const eventDataWithId = {
            ...eventData.data(),
            id: eventData.id,
            startdate: eventData.data()?.startdate ?? "",
          };
          setData(eventDataWithId);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    getData();
  }, [id]);

  return (
    <Box sx={{ flex: 1, width: "100%" }}>
      <img
        src={
          data.fileUrl ||
          "https://images.unsplash.com/photo-1502657877623-f66bf489d236"
        }
        alt=""
        style={{
          aspectRatio: "16/9",
          objectFit: "fill",
          width: "100%",
          height: "35vh",
          borderRadius: "10px",
        }}
      />
      <div className="pt-4"></div>
      <Tabs
        aria-label="Tabs"
        sx={{backgroundColor: "transparent"}}
        value={index}
        onChange={(event, value) => setIndex(value as number)}
      >
        <TabList
          sx={{
            pt: 1,
            justifyContent: "center",
            [`&& .${tabClasses.root}`]: {
              flex: "initial",
              bgcolor: "transparent",
              "&:hover": {
                bgcolor: "transparent",
              },
              [`&.${tabClasses.selected}`]: {
                color: "primary.plainColor",
                "&::after": {
                  height: 2,
                  borderTopLeftRadius: 3,
                  borderTopRightRadius: 3,
                  bgcolor: "primary.500",
                },
              },
            },
          }}
        >
          <Tab indicatorInset>Event Details</Tab>
          <Tab indicatorInset>Participant's Detail</Tab>
          <Tab indicatorInset>Event Statistics</Tab>
        </TabList>
        <Box
          sx={(theme) => ({
            "--bg": theme.vars.palette.background.surface,
            background: "var(--bg)",
            clipPath: "inset(0 -100vmax)",
            backgroundColor: "transparent",
          })}
        >
          <TabPanel value={0}>
            {" "}
            {loading ? <Loading /> : <EventDetailsContent data={data} />}
          </TabPanel>
          <TabPanel value={1}>
            <ParticipantDetails eventName={eventNametoBePassed} />
          </TabPanel>
          <TabPanel value={2}>
            <EventStats eventName={eventNametoBePassed} eventCategory={eventCategory}/>
          </TabPanel>
        </Box>
      </Tabs>
    </Box>
  );
}
